import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=c65988b2&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=js"
export * from "./appointment.vue?vue&type=script&lang=js"
import style0 from "./appointment.vue?vue&type=style&index=0&id=c65988b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65988b2",
  null
  
)

export default component.exports